'use client';

import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { observer } from 'mobx-react';
import SamplesGrid from './SamplesGrid';
import SampleDetailView from './SampleDetailView';
import AboutContent from './AboutContent';
import MainFooter from './MainFooter';


type MainPageContentProps = {
  mode?: 'samples' | 'about';
  searchQuery: string;
  onSearchChange?: (query: string) => void;
  showFavoritesOnly?: boolean;
  selectedComposer?: string | null;
};

const MainPageContent = observer(({ mode = 'samples', searchQuery, onSearchChange, showFavoritesOnly = false, selectedComposer }: MainPageContentProps) => {
  const searchParams = useSearchParams();
  const sampleIdentifier = searchParams.get('sheet-music');
  const containerRef = useRef<HTMLDivElement>(null);

  // Scroll to top when detail view opens
  useEffect(() => {
    if (sampleIdentifier) {
      // Scroll the parent overflow container to top
      const scrollContainer = containerRef.current?.parentElement;
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    }
  }, [sampleIdentifier]);

  if (mode === 'about') {
    return (
      <div className='min-h-full flex flex-col'>
        <div className='flex-1'>
          <AboutContent />
        </div>
        <div className='mx-5 sm:mx-8 mb-8'>
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div ref={containerRef} className='min-h-full flex flex-col'>
      <div className='flex-1 my-8 mx-5 sm:mx-8'>
        {sampleIdentifier ? (
          <SampleDetailView key={sampleIdentifier} identifier={sampleIdentifier} />
        ) : (
          <SamplesGrid searchQuery={searchQuery} onSearchChange={onSearchChange} showFavoritesOnly={showFavoritesOnly} selectedComposer={selectedComposer} />
        )}
      </div>
      <div className='mx-5 sm:mx-8 mb-8'>
        <MainFooter />
      </div>
    </div>
  );
});

export default MainPageContent;
